/* eslint-disable */
import React, { useEffect, Fragment, useState, useCallback } from 'react'
import Helmet from 'react-helmet'
import { useTranslation } from 'react-i18next'

import BackgroundHero from '../../static/images/hero-banner/halo-fix-background.svg'
import ImageHero from '../../static/images/hero-banner/halo-fix-image.svg'
import Mobile from '../../static/images/hero-banner/halo-fix-mobile.svg'
import HeroBanner from '../../components/hero-banner'
import DownloadMassage from '../../components/card-download'
import Testimonial from '../../components/testimonial'
import CardJoin from '../../components/card-join'
import WhyMassage from './why-massage'
import OnDemand from './on-demand'
import VendorFix from './vendor'
import ServiceMassage from './service-massage'
import BackgroundImage from '../../static/images/card-download/halo-fix.svg'
import BackgroundJoin from '../../static/images/card-join/background-fix.svg'
import ava from '../../static/icons/card-icon/ic-icon-auto.svg'
import IllustrationJoin from '../../static/images/card-join/illustration-fix.svg'
import {
  TitleHeroBanner,
  TitleSubHeroBanner,
  TitleTag,
  TitleHeroBannerForSeo
} from '../../components/text'
import ImageDownloadLink from '../../components/image-download/index'
import haloFixIllust from '../../static/images/card-join/halo-fix-illus.svg'
import image3 from '../../static/icons/testimonial/image-3.png'
import image7 from '../../static/icons/testimonial/image-7.png'
import image8 from '../../static/icons/testimonial/image-8.png'
import image2 from '../../static/icons/testimonial/image-2.png'
import MapFix from './map'
import FixedServices from '../../components/services-fixed/index'
import FixedServicesResponsive from '../../components/service-fixed-responsive/index'
import ServiceContent from '../../components/service-content'
import serviceContentConstant from '../../constants/service-content'
import ServiceProduct from '../../components/service-product'
import ServiceProductMobile from '../../components/service-product-mobile'
import { StyleDownload, StyleCardJoin } from './index.styles'

const {
  serviceContentType: { HF }
} = serviceContentConstant

const AboutPage = () => {
  const { t } = useTranslation()

  const [isActiveStick, setActiveStick] = useState(true)

  const hideStick = useCallback(() => {
    setActiveStick(false)
  }, [])

  const [isHeaderShow, setIsHeaderShow] = useState(false)
  const [nowPosition, setCurrentPosition] = useState(0)

  const trackScrolling = useCallback(() => {
    const currentScrollPos = window.pageYOffset
    if (currentScrollPos > nowPosition + 100) {
      setActiveStick(false)
    } else if (currentScrollPos < nowPosition + 200) {
      setActiveStick(true)
    }
    setCurrentPosition(currentScrollPos)
  }, [nowPosition])

  useEffect(() => {
    document.addEventListener('scroll', trackScrolling)
    return () => {
      document.removeEventListener('scroll', trackScrolling)
    }
  }, [trackScrolling])

  const renderServiceProduct = () => {
    if (window.innerWidth > 1023) return <ServiceProduct content={HF} />

    return <ServiceProductMobile content={HF} />
  }

  return (
    <Fragment>
      <Helmet>
        <title>Jasa Service AC Dan Cuci AC Jakarta | halojasa.com</title>
        <meta charSet="utf-8" />
        <meta
          name="description"
          content="Jasa Service AC siap melayani cuci, perbaikan, pasang AC dan isi freon AC.  untuk seluruh wilayah Jakarta, Bekasi, Tangerang, Bogor."
        />
        <meta
          property="og:title"
          content="Jasa Service AC Dan Cuci AC Jakarta | halojasa.com"
        />
        <meta property="og:site_name" content="Halo Jasa" />
        <meta
          property="og:description"
          content="Jasa Service AC siap melayani cuci, perbaikan, pasang AC dan isi freon AC.  untuk seluruh wilayah Jakarta, Bekasi, Tangerang, Bogor."
        />
        <meta
          property="og:url"
          content="https://halojasa.com/service-ac-jakarta/"
        />
        <meta
          property="og:image"
          content="https://halojasa.com/blog/wp-content/uploads/2020/06/halofix-ls.png"
        />
        <meta
          property="og:image:secure_url"
          content="https://halojasa.com/blog/wp-content/uploads/2020/06/halofix-ls.png"
        />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta
          property="og:image"
          itemProp="image"
          content="https://halojasa.com/blog/wp-content/uploads/2020/06/halofix-sq.png"
        />
        <meta
          property="og:image:secure_url"
          itemProp="image"
          content="https://halojasa.com/blog/wp-content/uploads/2020/06/halofix-sq.png"
        />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="300" />
        <meta property="og:image:height" content="268" />
        <meta property="og:type" content="website" />
        <meta property="fb:app_id" content="951866408583742" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@pthalojasa" />
        <meta
          name="twitter:title"
          content="Jasa Service AC Dan Cuci AC Jakarta | halojasa.com"
        />
        <meta
          name="twitter:description"
          content="Jasa Service AC siap melayani cuci, perbaikan, pasang AC dan isi freon AC.  untuk seluruh wilayah Jakarta, Bekasi, Tangerang, Bogor."
        />
        <meta
          name="twitter:image:src"
          content="https://halojasa.com/blog/wp-content/uploads/2020/06/halofix-ls.png"
        />
        <meta
          name="keyword"
          content="service ac, service ac jakarta, service ac bekasi, service ac tangerang, tukang servis ac, jasa bongkar pasang ac"
        />
        <meta
          name="p:domain_verify"
          content="4e6fcb4deba1a02d84225fad69babc0b"
        />
        <link rel="canonical" href="https://halojasa.com/service-ac-jakarta/" />
      </Helmet>
      <HeroBanner
        title={
          <div>
            <TitleHeroBannerForSeo align="left">
              {t('pageServiceAcJakarta.part53')}
            </TitleHeroBannerForSeo>
            <TitleHeroBanner className="hero-title uppercase" align="left">
              Halo FIX - Daily Urban
            </TitleHeroBanner>
            <TitleHeroBanner className="hero-title uppercase" align="left">
              Lifestyle Service
            </TitleHeroBanner>
          </div>
        }
        picture={{
          background: BackgroundHero,
          image: ImageHero,
          mobile: Mobile
        }}
        subTitleHeroBanner={
          <TitleSubHeroBanner
            className="title-sub-banner fix-color"
            align="left"
          >
            {t('pageServiceAcJakarta.part1')}
          </TitleSubHeroBanner>
        }
        paragraph={
          <div>
            <p className="hero-desc">{t('pageServiceAcJakarta.part3')}</p>
            <p className="hero-desc">{t('pageServiceAcJakarta.part4')}</p>
            <h2 className="hero-seo">{t('pageServiceAcJakarta.part54')}</h2>
            <ImageDownloadLink />
          </div>
        }
        tag={<TitleTag>#{t('pageServiceAcJakarta.part2')}</TitleTag>}
        breadCrumb={[
          {
            name: 'Beranda',
            link: '/'
          },
          {
            name: 'Layanan Kami',
            link: '/'
          },
          {
            name: 'Halo Fix',
            link: false
          }
        ]}
      ></HeroBanner>

      {renderServiceProduct()}

      <div id="content-body">
        <WhyMassage></WhyMassage>

        <ServiceMassage></ServiceMassage>

        <MapFix></MapFix>

        <StyleDownload>
          <DownloadMassage
            contentImage={haloFixIllust}
            boxShadow="0 10px 10px 0 rgba(143, 116, 255, 0.05)"
            border="solid 1px #e3dbff"
            backgroundImage={BackgroundImage}
            title={t('pageServiceAcJakarta.part36')}
            tag={`# ${t('pageServiceAcJakarta.part2')}`}
            desc={t('pageServiceAcJakarta.part37')}
          ></DownloadMassage>
        </StyleDownload>

        <VendorFix></VendorFix>

        <OnDemand></OnDemand>

        <StyleCardJoin>
          <CardJoin
            marginTop="100px"
            boxShadow="0 10px 10px 0 rgba(143, 116, 255, 0.05)"
            border="solid 1px #e3dbff"
            backgroundImage={BackgroundJoin}
            ava={ava}
            image={IllustrationJoin}
            buttonColor="linear-gradient(to left, #b34ef0, #4950e9)"
            title="Halo Fix – AC Kembali Sedingin Semula"
            tag="#solusimaudingin"
            desc={t('pageServiceAcJakarta.part51')}
          ></CardJoin>
        </StyleCardJoin>

        <Testimonial
          data={[
            {
              name: 'Bpk Kurniawan',
              desc:
                '"Proses awal bertemu penyedia jasa ramah dan sopan serta memberikan informasi yang jelas dari semua step pekerjaan yang dilakukan."',
              job: 'Bisnis Owner',
              avatarImage: image7,
              key: 1
            },
            {
              name: 'Ibu Anggi',
              desc:
                '"Orderan saya direspon dengan cepat dan pekerjaan dapat dikerjakan sesuai dengan jadwal yang saya butuhkan."',
              job: 'Ibu rumah tangga',
              avatarImage: image3,
              key: 2
            },
            {
              name: 'Bpk Vino',
              desc:
                '"Sekarang saya sudah tidak pernah kecewa sama perlakuan nakal tukang service ac, yang sering bilang freon ac setiap service harus ditambah."',
              job: 'Bisnis Owner ',
              avatarImage: image8,
              key: 3
            },
            {
              name: 'Ibu Diora ',
              desc:
                '"AC saya dulu sering bocor dan menetes air, ternyata saluran sering mampet karena kotoran setiap kali saya melakukan maintanen, saluran AC selalu dibersihkan."',
              job: 'Wirausaha',
              avatarImage: image2,
              key: 4
            }
          ]}
        ></Testimonial>
        <ServiceContent
          content={HF}
          isWeb={window.innerWidth > 1023 ? true : false}
        />
        {window.innerWidth > 1023 ? (
          <FixedServices></FixedServices>
        ) : (
          <FixedServicesResponsive></FixedServicesResponsive>
        )}
      </div>
    </Fragment>
  )
}

export default AboutPage
